import { useState, type ReactNode } from 'react';
import { MateriaallijstenNietGereed } from '@/components/controle/MateriaallijstenNietGereed';
import { OaPoAudit } from '@/components/controle/OaPoAudit';

/**
 * Controle — admin "mistake catching" dashboard.
 *
 * A container of diagnostic checks. Each check is one entry in CHECKS below and
 * renders its own component. To add a check: write the component, add a CHECK
 * entry, done — the sub-tab bar and routing are driven off this array.
 */
interface ControleCheck {
  key: string;
  label: string;
  render: () => ReactNode;
}

const CHECKS: ControleCheck[] = [
  {
    key: 'materiaallijsten',
    label: 'Materiaallijsten niet gereed',
    render: () => <MateriaallijstenNietGereed />,
  },
  {
    key: 'oa-pos',
    label: 'Onderaannemers — lopende PO’s',
    render: () => <OaPoAudit />,
  },
];

export function ControleView() {
  const [active, setActive] = useState(CHECKS[0].key);
  const activeCheck = CHECKS.find((c) => c.key === active) ?? CHECKS[0];

  return (
    <div className="min-h-full bg-slate-100">
      {/* Page header */}
      <div className="bg-white border-b border-slate-200 px-8 py-5">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-td-navy">Controle</h1>
          <span className="px-2 py-0.5 rounded-full bg-td-magenta/10 text-td-magenta text-[11px] font-semibold">
            admin
          </span>
        </div>
        <p className="text-sm text-slate-500 mt-1">
          Foutcontrole — dingen die ergens blijven hangen of verkeerd staan.
        </p>
      </div>

      {/* Sub-tab bar */}
      <div className="bg-white border-b border-slate-200 px-8">
        <div className="flex gap-1 -mb-px overflow-x-auto">
          {CHECKS.map((check) => (
            <button
              key={check.key}
              type="button"
              onClick={() => setActive(check.key)}
              className={`px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition ${
                check.key === active
                  ? 'text-td-blue border-td-blue'
                  : 'text-slate-400 border-transparent hover:text-slate-600'
              }`}
            >
              {check.label}
            </button>
          ))}
        </div>
      </div>

      {activeCheck.render()}
    </div>
  );
}
